import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_INT_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/onboarding/pre-cadastro/log-integracao`;
export default{
    async listarLogPorDataIntegracao(dataIntegracaoInicial, dataIntegracaoFinal, idPais, correlationId, jobRequisionId, indicadorInclusao, indicadorSucesso){
        let url = `${baseUrl}/${encodeURI(idPais)}/${dataIntegracaoInicial}/${dataIntegracaoFinal}?`;

        if(correlationId != null && correlationId != undefined)
            url = `${url}correlationId=${encodeURI(correlationId)}&`;               

        if(jobRequisionId != null && jobRequisionId != undefined)
            url = `${url}jobRequisionId=${encodeURI(jobRequisionId)}&`;                   

        if(indicadorInclusao != null && indicadorInclusao != undefined)
            url = `${url}indicadorInclusao=${encodeURI(indicadorInclusao)}&`;                     

        if(indicadorSucesso != null && indicadorSucesso != undefined)
            url = `${url}indicadorSucesso=${encodeURI(indicadorSucesso)}&`;                               

        return await Vue.prototype.$httpJson.get(url.substring(0, url.length - 1));
    }
}